import { Link } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as Icons from '@iconscout/react-unicons';
import type { FC } from 'react';
import { TextLink } from '../../typography';
import { IconLink } from '../../components';
import { ReactComponent as SignLogo } from './images/logo.svg';
import s from './index.module.scss';

export const Header: FC = () => {
  return (
    <header className={s.header}>
      <div className={s.layout}>
        <Link to="/" className={s.logo}>
          <SignLogo width="2em" height="2em" color="var(--text-color-3)" />
        </Link>
        <nav className={s.nav}>
          <TextLink to="/projects" size="1" color="3" isUnderline={false} className={s.navLink}>
            Projects
          </TextLink>
          <TextLink to="/highlights" size="1" color="3" isUnderline={false} className={s.navLink}>
            Highlights
          </TextLink>
          <IconLink href="https://github.com/gzhel" title="GitHub" className={s.navLink}>
            <Icons.UilGithubAlt width="1.2em" height="1.2em" color="var(--text-color-3)" />
          </IconLink>
          <IconLink
            href="https://www.linkedin.com/in/gzhel/"
            title="LinkedIn"
            className={s.navLink}
          >
            <Icons.UilLinkedinAlt width="1.2em" height="1.2em" color="var(--text-color-3)" />
          </IconLink>
        </nav>
      </div>
    </header>
  );
};
